var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('h1',{staticClass:"sz-6 text-center"},[(_vm.backButton)?_c('a',{staticClass:"align--no-descenders",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('inline',{staticClass:"sz-3 text-icon-subtle",attrs:{"svg":"chevron-left"}})],1):_vm._e(),_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }